import en from "./en.json";
import fr from "./fr.json";
import es from "./es.json";
import de from "./de.json";
import it from "./it.json";
import pt from "./pt.json";
import ja from "./ja.json";
import zh from "./zh.json";
import ar from "./ar.json";
import nl from "./nl.json";

const bundles: Record<string, Record<string, string>> = { en, fr, es, de, it, pt, ja, zh, ar, nl };

export function t(key: string, lang: string, params?: Record<string, string | number>): string {
  const bundle = bundles[lang] ?? bundles.en;
  let value = bundle[key] ?? bundles.en[key] ?? key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      value = value.replace(`{${k}}`, String(v));
    }
  }
  return value;
}
